import { render, staticRenderFns } from "./DepositWithdraw.vue?vue&type=template&id=65eb98b6&scoped=true&"
import script from "./DepositWithdraw.vue?vue&type=script&lang=ts&"
export * from "./DepositWithdraw.vue?vue&type=script&lang=ts&"
import style0 from "./DepositWithdraw.vue?vue&type=style&index=0&id=65eb98b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb98b6",
  null
  
)

export default component.exports